export default __webpack_public_path__ + "static/media/0.791f1c33.png";